import React, { useContext, useEffect, useRef, Fragment } from 'react';
import { useObserver } from 'mobx-react-lite';
import FadeIn from 'react-fade-in';
import { GlobalHotKeys } from 'react-hotkeys';
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';

import QuickDrawerHeader from '../../_shared/QuickDrawerHeader';
import { quickDrawerFocus, renderQuickDrawerLoading } from '../../_shared/QuickDrawer';

import QuickDrawerStore from '../../../../stores/QuickDrawerStore';

import * as fn from '../../../../utilities/_functions';
import * as ph from '../../../../utilities/personHelper';
import * as oh from '../../../../utilities/operationHelper';
import * as bk from '../../../../utilities/onlineBookingHelper';
import * as sys from '../../../../utilities/systemHelper';

import './ViewBooking.scss';

moment.locale('en');
momentLocalizer();

function ViewBooking(props) {
    const quickDrawerTimer = useRef(null);
    const quickDrawer = useContext(QuickDrawerStore);

    useEffect(() => {

        quickDrawerFocus(props.drawer);

        return () => {
            if (quickDrawerTimer.current) { clearTimeout(quickDrawerTimer.current); quickDrawerTimer.current = null; }
        }
    }, []) // eslint-disable-line

    const renderResource = (resource) => {
        return <div
            className='profile-wrapper pr-0'
        >
            <div className='profile'>
                <span
                    className={`profile-image rounded-circle d-block fw-500` + (resource && !resource.profilePictureUri ? ` profile-initials bg-color${resource.color}-500` : '')}
                    style={resource && resource.profilePictureUri ? {
                        backgroundImage: `url(${resource.profilePictureUri})`,
                        backgroundSize: 'cover',
                    } : null}
                    title={resource ? resource.fullName : 'System'}>
                    {resource && !resource.profilePictureUri ? <div className='d-initials'>{resource.initials}</div> : null}
                </span>
            </div>
            <div className='description flex-1'>
                <div className='name'>{resource.fullName}</div>
            </div>
        </div>
    }

    const renderNewOrReturn = (bookingItem) => {
        const isNewOrReturn = bookingItem.isNewOrReturn;

        if (isNewOrReturn) {
            switch (isNewOrReturn.toLowerCase()) {
                case 'new':
                    return <>New Patient</>;

                case 'return':
                    return <>Returning Patient</>;

                default:
                    break;
            }
        }

        return <>Not sure</>
    }

    return useObserver(() => <>
        <>
            {
                (props.drawer === quickDrawer.drawerOpened) ?
                    <GlobalHotKeys
                        keyMap={{
                            close: ['esc'],
                        }}
                        handlers={{
                            close: event => {
                                props.onCancel(event)
                            },
                        }}
                        allowChanges={true}
                    /> : null
            }
        </>
        <form>
            <fieldset>
                <div className='quick-drawer'>
                    <QuickDrawerHeader
                        drawer={props.drawer}
                        icon={oh.getIcon('appointment')}
                        action='View'
                        category='Online Booking Information'
                        className='appointments'
                        onCancel={props.onCancel}
                    />
                    <div className='quick-drawer-body'>
                        {
                            props.extraProps.appointment && props.extraProps.bookings && props.extraProps.bookings.length > 0 ?
                                <FadeIn>
                                    <div className='view-booking-item body-content'>
                                        <section className='resource'>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-0'>
                                                        <label><small>Booked With</small></label>
                                                        {renderResource(props.extraProps.appointment.resource)}
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        {
                                            props.extraProps.bookings.map((booking, bi) => {
                                                const bookingItem = bk.getBookingItem(booking);
                                                const bookingType = bk.getBookingType(booking);

                                                return <Fragment
                                                    key={`booking-item-${bi}`}
                                                >
                                                    {
                                                        bi > 0 ?
                                                            <section className='m-0'>
                                                                <div className='row'>
                                                                    <div className='col-12'><hr /></div>
                                                                </div>
                                                            </section> : null
                                                    }
                                                    <section className='booking-info'>
                                                        <div className='row mb-3'>
                                                            <div className='col-12'>
                                                                <div className='text-gray-700 fw-500'>Booking Information{props.extraProps.bookings.length > 1 ? ` #${(bi + 1)}` : ''}{booking.referenceNumber ? <> (Ref #: {booking.referenceNumber})</> : <></>}</div>
                                                                <div className='text-gray-600'>{sys.getFormattedLongDate(moment.utc(booking.createdDateUtc).local(), true)}</div>
                                                            </div>
                                                        </div>
                                                        <div className='row mb-3'>
                                                            <div className='col-6'>
                                                                <small className="text-gray-500 text-uppercase fw-500 d-block">First Name</small>
                                                                {bookingItem.firstName}
                                                            </div>
                                                            <div className='col-6'>
                                                                <small className="text-gray-500 text-uppercase fw-500 d-block">Last Name</small>
                                                                {bookingItem.lastName}
                                                            </div>
                                                        </div>
                                                        {
                                                            (
                                                                bookingType.dateOfBirthQuestion ||
                                                                bookingType.sexQuestion ||
                                                                bookingType.genderQuestion ||
                                                                bookingType.pronounQuestion
                                                            ) ?
                                                                <>
                                                                    {
                                                                        bookingType.dateOfBirthQuestion ?
                                                                            <div className='row mb-3'>
                                                                                <div className='col-6'>
                                                                                    <small className="text-gray-500 text-uppercase fw-500 d-block">Date of Birth</small>
                                                                                    <span>{bookingItem.dateOfBirth ? sys.getFormattedLongDate(moment(bookingItem.dateOfBirth)) : '--'}</span>
                                                                                </div>
                                                                                <div className='col-6'>
                                                                                    <small className="text-gray-500 text-uppercase fw-500 d-block">Age <span className='tt-normal'>(on date of the appointment)</span></small>
                                                                                    <span>{bookingItem.dateOfBirth ? ph.getAge(moment(bookingItem.dateOfBirth).startOf('day'), moment(props.extraProps.appointment.start).startOf('day')) : '--'}</span>
                                                                                </div>
                                                                            </div> : null
                                                                    }
                                                                    {
                                                                        (
                                                                            (
                                                                                bookingType.sexQuestion ||
                                                                                bookingType.genderQuestion ||
                                                                                bookingType.pronounQuestion
                                                                            ) ?
                                                                                <div className='row mb-3'>
                                                                                    <div className='col-12'>
                                                                                        <small className="text-gray-500 text-uppercase fw-500 d-block">
                                                                                            {
                                                                                                [
                                                                                                    ...bookingType.sexQuestion ? ['Sex'] : [],
                                                                                                    ...bookingType.genderQuestion ? ['Gender'] : [],
                                                                                                    ...bookingType.pronounQuestion ? ['Pronoun'] : [],
                                                                                                ].join(' | ')
                                                                                            }
                                                                                        </small>
                                                                                        <>
                                                                                            {
                                                                                                [
                                                                                                    ...bookingType.sexQuestion ? [bookingItem.sex ? ph.getSexDescription(bookingItem.sex) : '--'] : [],
                                                                                                    ...bookingType.genderQuestion ? [bookingItem.gender ? ph.getGenderDescription(bookingItem.gender) : '--'] : [],
                                                                                                    ...bookingType.pronounQuestion ? [bookingItem.pronoun ? ph.getPronounDescription(bookingItem.pronoun) : '--'] : [],
                                                                                                ].join(' | ')
                                                                                            }
                                                                                        </>
                                                                                    </div>
                                                                                </div> : null
                                                                        )
                                                                    }
                                                                </> : null
                                                        }
                                                        <div className='row mb-3'>
                                                            <div className='col'>
                                                                <small className="text-gray-500 text-uppercase fw-500 d-block">Email</small>
                                                                {bookingItem.emailAddress}
                                                            </div>
                                                        </div>
                                                        {
                                                            bookingType.phoneQuestion ?
                                                                <div className='row mb-3'>
                                                                    <div className='col'>
                                                                        <small className="text-gray-500 text-uppercase fw-500 d-block">Mobile Phone</small>
                                                                        {bookingItem.phoneNumber ? sys.getFormattedPhoneNumber(bookingItem.phoneNumber) : '--'}
                                                                    </div>
                                                                </div> : null
                                                        }
                                                        {
                                                            bookingType.isNewOrReturnQuestion ?
                                                                <div className='row mb-3'>
                                                                    <div className='col'>
                                                                        <small className="text-gray-500 text-uppercase fw-500 d-block">New or Return</small>
                                                                        {bookingItem.isNewOrReturn ? renderNewOrReturn(bookingItem) : 'Not sure'}
                                                                    </div>
                                                                </div> : null
                                                        }
                                                        {
                                                            bookingItem.customQuestion1 && bookingItem.customQuestion1Answer ?
                                                                <div className='row mb-3'>
                                                                    <div className='col'>
                                                                        <small className="text-gray-500 text-uppercase fw-500 d-block">{bookingItem.customQuestion1}</small>
                                                                        <span dangerouslySetInnerHTML={{
                                                                            __html: fn.plainTextToHtml(bookingItem.customQuestion1Answer)
                                                                        }}></span>
                                                                    </div>
                                                                </div> : null
                                                        }
                                                        {
                                                            bookingItem.customQuestion2 && bookingItem.customQuestion2Answer ?
                                                                <div className='row mb-3'>
                                                                    <div className='col'>
                                                                        <small className="text-gray-500 text-uppercase fw-500 d-block">{bookingItem.customQuestion2}</small>
                                                                        <span dangerouslySetInnerHTML={{
                                                                            __html: fn.plainTextToHtml(bookingItem.customQuestion2Answer)
                                                                        }}></span>
                                                                    </div>
                                                                </div> : null
                                                        }
                                                        {
                                                            bookingItem.customQuestion3 && bookingItem.customQuestion3Answer ?
                                                                <div className='row mb-3'>
                                                                    <div className='col'>
                                                                        <small className="text-gray-500 text-uppercase fw-500 d-block">{bookingItem.customQuestion3}</small>
                                                                        <span dangerouslySetInnerHTML={{
                                                                            __html: fn.plainTextToHtml(bookingItem.customQuestion3Answer)
                                                                        }}></span>
                                                                    </div>
                                                                </div> : null
                                                        }
                                                        {
                                                            bookingType.messageQuestion ?
                                                                <div className='row mb-3'>
                                                                    <div className='col'>
                                                                        <small className="text-gray-500 text-uppercase fw-500 d-block">Message</small>
                                                                        <span dangerouslySetInnerHTML={{
                                                                            __html:
                                                                                bookingItem.message ?
                                                                                    fn.plainTextToHtml(bookingItem.message) : '--'
                                                                        }}></span>
                                                                    </div>
                                                                </div> : null
                                                        }
                                                    </section>
                                                </Fragment>
                                            })
                                        }
                                    </div>
                                </FadeIn> : renderQuickDrawerLoading()
                        }
                    </div>
                    <div className='quick-drawer-action pl-3'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='float-right'>
                                    <button
                                        type='button'
                                        className='btn btn-info'
                                        onClick={props.onCancel}
                                    >
                                        Done
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </form>
    </>)
}

export default ViewBooking;